import type { UserRepository } from '#/domain/user/UserRepository'

export class RemoveMemberUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, organizationId?: string): Promise<void> {
    return this.repository.removeMember(userId, organizationId)
  }
}
